module.exports = __webpack_public_path__ + "static/media/Ein_Tag_Deutsch_Zusatzmaterialien_gesamt.42c8d3b9.pdf";